// VFX: Bokeh Depth Loop
// Category: bokeh-depth · Tags: background, bokeh, depth, cinematic, ambient
// Circulos desfocados flutuando — profundidade de campo cinematografica. Loop ambiente.
import { AbsoluteFill, useCurrentFrame } from "remotion";
import React from "react";

const BOKEH = Array.from({ length: 22 }, (_, i) => ({
  x: (i * 31 + 12) % 100,
  y: (i * 47 + 8) % 100,
  size: 30 + (i % 5) * 40,
  delay: i * 0.4,
  opacity: 0.12 + (i % 4) * 0.06,
  color: ["#a855f7", "#06b6d4", "#f97316", "#10b981", "#ef4444"][i % 5],
}));

export default function BgBokehDepthCirclesLoop() {
  const frame = useCurrentFrame();
  return (
    <AbsoluteFill style={{ background: "radial-gradient(circle at 50% 50%, #1e293b 0%, #0a0e1a 100%)", overflow: "hidden" }}>
      {BOKEH.map((b, i) => {
        const drift = Math.sin(frame * 0.015 + b.delay) * 4;
        const driftY = Math.cos(frame * 0.012 + b.delay) * 5;
        const scalePulse = 1 + Math.sin(frame * 0.02 + b.delay) * 0.15;
        return (
          <div key={i} style={{
            position: "absolute",
            left: `${b.x + drift}%`, top: `${b.y + driftY}%`,
            width: b.size, height: b.size, borderRadius: "50%",
            background: b.color, opacity: b.opacity,
            filter: "blur(28px)",
            transform: `scale(${scalePulse}) translate(-50%, -50%)`,
          }} />
        );
      })}
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
